function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { isPrimitive as i } from "../predicate/isPrimitive.js";
import { isTypedArray as f } from "../predicate/isTypedArray.js";
function c(e) {
  if (i(e)) return e;
  if (Array.isArray(e) || f(e) || e instanceof ArrayBuffer || (typeof SharedArrayBuffer === "undefined" ? "undefined" : _typeof(SharedArrayBuffer)) < "u" && e instanceof SharedArrayBuffer) return e.slice(0);
  var r = Object.getPrototypeOf(e),
    t = r.constructor;
  if (e instanceof Date || e instanceof Map || e instanceof Set) return new t(e);
  if (e instanceof RegExp) {
    var n = new t(e);
    return n.lastIndex = e.lastIndex, n;
  }
  if (e instanceof DataView) return new t(e.buffer.slice(0));
  if (e instanceof Error) {
    var _n = new t(e.message);
    return _n.stack = e.stack, _n.name = e.name, _n.cause = e.cause, _n;
  }
  if ((typeof File === "undefined" ? "undefined" : _typeof(File)) < "u" && e instanceof File) return new t([e], e.name, {
    type: e.type,
    lastModified: e.lastModified
  });
  if (_typeof(e) == "object") {
    var _n2 = Object.create(r);
    return Object.assign(_n2, e);
  }
  return e;
}
export { c as clone };